import type React from 'react';

export interface VerticalBarsIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	stroke?: string;
	'aria-label'?: string;
}

const VerticalBarsIcon: React.FC<VerticalBarsIconProps> = ({
	width = 13,
	height = 17,
	fill = 'currentColor',
	stroke = 'none',
	'aria-label': ariaLabel = 'Vertical Bars Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 13 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
	>
		<title>{ariaLabel}</title>
		<rect
			x="13"
			y="0.5"
			width="16"
			height="3"
			rx="1.5"
			transform="rotate(90 13 0.5)"
			fill={fill}
			stroke={stroke}
		/>
		<rect
			x="8"
			y="0.5"
			width="16"
			height="3"
			rx="1.5"
			transform="rotate(90 8 0.5)"
			fill={fill}
			stroke={stroke}
		/>
		<rect
			x="3"
			y="0.5"
			width="16"
			height="3"
			rx="1.5"
			transform="rotate(90 3 0.5)"
			fill={fill}
			stroke={stroke}
		/>
	</svg>
);

export default VerticalBarsIcon;
